// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1QBs7","error":"Textarea_error__2m3VB","readonly":"Textarea_readonly__FYXW3","disabled":"Textarea_disabled__G6iwu"};